import { render } from "./UnitsList_navigation.vue?vue&type=template&id=9b4acc54"
import script from "./UnitsList_navigation.vue?vue&type=script&lang=js"
export * from "./UnitsList_navigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__